import dayjs from 'dayjs';

/**
 * Checks to see if the date range should be shown
 * @param { string } first The first date to check
 * @param { string } second The second date to check
 * @returns { boolean }
 */
export const shouldShowDateRange = (earliest, latest) => {
  if (!dayjs(earliest).isValid() || !dayjs(latest).isValid()) {
    return false;
  }
  const firstDay = dayjs(earliest);
  const secondDay = dayjs(latest);
  return !!earliest && !!latest && !firstDay.isSame(secondDay, 'day');
};
